export enum UserRole {
  COMPANY_ADMIN = 'COMPANY_ADMIN_ROLE',
  COMPANY_SERVICE = 'COMPANY_SERVICE_ROLE',
  CUSTOMER_SUCCESS = 'CUSTOMER_SUCCESS_ROLE',
  DATA_SCIENCE = 'DATA_SCIENCE_ROLE',
  ENGINEERING = 'ENGINEERING_ROLE',
  SALES = 'SALES_ROLE',
  TRUSTAR_ADMIN = 'ADMIN_ROLE',
  USER = 'USER_ROLE',
}

export enum UserPermission {
  USE_STATION_PERMISSION = 'use_station',
  MANAGE_COMPANY_USERS_PERMISSION = 'manage_company_users',
  MANAGE_MARKETPLACE_PERMISSION = 'manage_marketplace',
  MANAGE_EMAIL_INGEST_PERMISSION = 'manage_email_ingest',
  MANAGE_REDACTION_LIBRARY_PERMISSION = 'manage_redaction_library',
  MANAGE_ENCLAVES_PERMISSION = 'manage_enclaves',
  MANAGE_TEMPLATES_PERMISSION = 'manage_templates',
  MANAGE_COMPANIES_PERMISSION = 'manage_companies',
  MANAGE_WORKFLOWS_PERMISSION = 'manage_workflows',
  MANAGE_SAFELISTS_PERMISSION = 'manage_safelists',
  SET_ANY_USER_PASSWORD_PERMISSION = 'set_any_user_password',
  GET_USER_DATA_PERMISSION = 'get_user_data',
  GET_ENCLAVES_PERMISSION = 'get_enclaves',
  GET_COMPANIES_PERMISSION = 'get_companies',
  MANAGE_MALWARE_PERMISSION = 'manage_malware',
  MANAGE_THREAT_ACTORS_PERMISSION = 'manage_threat_actors',
  MANAGE_WHITELIST_PERMISSION = 'manage_whitelist',
  GRANT_INTERNAL_ROLES_PERMISSION = 'grant_internal_roles',
  ADMINISTER_MARKETPLACE_PERMISSION = 'administer_marketplace',
  DEBUG_PERMISSION = 'debug',
}
